import type { Infer } from 'superstruct';
import { array, number, object, optional, record, string } from 'superstruct';

export const FacebookCustomAudienceItemDto = object({
	id: string(),
	name: optional(string()),
	subtype: optional(string()),
	approximate_count: optional(number()),
});

export type FacebookCustomAudienceItemDto = Infer<
	typeof FacebookCustomAudienceItemDto
>;

export const FacebookCustomAudienceTemplateDto = record(
	string(),
	object({
		included: array(FacebookCustomAudienceItemDto),
		excluded: array(FacebookCustomAudienceItemDto),
	})
);

export type FacebookCustomAudienceTemplateDto = Infer<
	typeof FacebookCustomAudienceTemplateDto
>;
